import type { SVGProps } from 'react';
const SvgArrowTurnDownRightStreamlineCore = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={14} height={14} fill="none" viewBox="0 0 14 14" {...props}>
    <desc>{'Arrow Turn Down Right Streamline Icon: https://streamlinehq.com'}</desc>
    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M3 2.5V8a1.5 1.5 0 0 0 1.5 1.5H11" />
    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M9 7.5 11 9.5 9 11.5" />
  </svg>
);
export default SvgArrowTurnDownRightStreamlineCore;
